export default __webpack_public_path__ + "static/media/Geode.9165c8e5.svg";